import { BooleanField, useStore } from "react-admin";
import { isAsharaEvent } from "@/utils";
import type { CurrentEvent } from "@/containers/events/types";

type MemberRecord = {
  hasChair?: boolean;
  hasRelay?: boolean;
};

const yesNo = (value: boolean | undefined) => (value ? "Yes" : "No");

export const formatNiyaazMemberToggleSuffix = (
  record: MemberRecord,
  showRelay: boolean
): string => {
  const parts = [`Chair: ${yesNo(record.hasChair)}`];
  if (showRelay) {
    parts.push(`Relay: ${yesNo(record.hasRelay)}`);
  }
  return ` · ${parts.join(" · ")}`;
};

export const useNiyaazShowRelayColumn = () => {
  const [currentEvent] = useStore<CurrentEvent | null>("currentEvent", null);
  return isAsharaEvent(currentEvent ?? undefined);
};

export const NiyaazShowMemberChairField = () => (
  <BooleanField source="hasChair" label="Chair" valueLabelTrue="Yes" valueLabelFalse="No" />
);

export const NiyaazShowMemberRelayField = () => (
  <BooleanField source="hasRelay" label="Relay" valueLabelTrue="Yes" valueLabelFalse="No" />
);
